import { useEffect } from "react";

interface SeoOptions {
  title: string;
  description: string;
  canonical: string;
  robots?: string; // e.g. "noindex,nofollow"
}

function setMeta(name: string, content: string, attr: "name" | "property" = "name") {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Per-route SEO. Updates document title, meta description, canonical, robots,
 * and the corresponding OG/Twitter tags. Purely presentational - no business logic.
 */
export function useSeo({ title, description, canonical, robots }: SeoOptions) {
  useEffect(() => {
    document.title = title;
    setMeta("description", description);
    setCanonical(canonical);

    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:url", canonical, "property");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);

    setMeta("robots", robots ?? "index,follow");
  }, [title, description, canonical, robots]);
}
